"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    label: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.grey) === null || _theme$palette === void 0 ? void 0 : _theme$palette[300],
      fontSize: "0.875rem"
    },
    skeleton: {
      paddingBottom: 4,
      paddingTop: 4
    }
  };
});
var _default = exports.default = styles;